angular.module('gym.invoices').controller('InvoiceCancellationCtrl', ["$scope", "$rootScope", "$modalInstance", "$filter", "flash", "InvoiceRescheduleService", "invoice", function($scope, $rootScope, $modalInstance, $filter, flash, InvoiceRescheduleService, invoice) {
  var save, validate;
  $scope.gym = $rootScope.gym;
  $scope.currency_symbol = $scope.gym.currency_symbol;
  $scope.invoice = invoice;
  $scope.params = {};
  $scope.minDate = moment($scope.gym.today).toDate();
  if (invoice.grouped_invoice_id) {
    $scope.groupedInvoices = invoice.all('list_group').getList().$object;
  }
  validate = function() {
    $scope.invoice.rescheduled_due_date = $scope.params.rescheduled_due_date;
    return InvoiceRescheduleService.validate($scope.invoice);
  };
  $scope.amount = function(invoice) {
    if (invoice.amount_cents) {
      return invoice.amount_cents / 100;
    } else {
      return invoice.amount;
    }
  };
  save = function() {
    var params, resource;
    params = {
      withoutNamespace: true,
      'invoice[cancel_action]': $scope.params.cancel_action,
      'invoice[rescheduled_due_date]': $scope.params.rescheduled_due_date
    };
    resource = invoice.grouped_invoice_id ? 'cancel_group' : 'cancel';
    return $scope.invoice.doPUT({}, resource, params).then(function(response) {
      return $modalInstance.close();
    }, function(response) {
      $scope.isLoading = false;
      return flash.error = "Request could not be completed. Please try again";
    });
  };
  $scope.isFormReady = function() {
    var cancel_action, rescheduled_due_date;
    cancel_action = $scope.params.cancel_action;
    rescheduled_due_date = $scope.params.rescheduled_due_date;
    if (!cancel_action) {
      return false;
    }
    if (cancel_action === 'cancel_and_reschedule') {
      return !!rescheduled_due_date;
    } else {
      return true;
    }
  };
  $scope.submit = function() {
    $scope.isLoading = true;
    if ($scope.params.cancel_action === 'cancel_and_reschedule') {
      return validate().then(function() {
        return save();
      }, function() {
        return $scope.isLoading = false;
      });
    } else {
      return save();
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
